import { createReducer, on } from '@ngrx/store';
import { InfoPopupDialogState } from './info-popup-dialog.state';
import { infoPopupDialogStateInitial } from './info-popup-dialog.state.initial';
import { InfoPopupDialogActions } from './info-popup-dialog.actions';

/**
 * Reducer für den Info-Popup-Dialog.
 */
export const infoPopupDialogReducers = createReducer(
  infoPopupDialogStateInitial,

  on(
    InfoPopupDialogActions.openPreview,
    (state, { previewData }): InfoPopupDialogState => ({
      ...state,
      isOpen: true,
      mode: 'preview',
      previewData,
    }),
  ),

  on(
    InfoPopupDialogActions.openUserPopup,
    (state): InfoPopupDialogState => ({
      ...state,
      isOpen: true,
      mode: 'user',
      previewData: undefined,
    }),
  ),

  on(
    InfoPopupDialogActions.close,
    (state): InfoPopupDialogState => ({
      ...state,
      isOpen: false,
    }),
  ),
);
